module.exports = __webpack_public_path__ + "img/wisemobileapp.beb38756.png";